import { render, staticRenderFns } from "./labelAutocompleteList.vue?vue&type=template&id=0c3c5113&scoped=true"
import script from "./labelAutocompleteList.vue?vue&type=script&lang=js"
export * from "./labelAutocompleteList.vue?vue&type=script&lang=js"
import style0 from "./labelAutocompleteList.vue?vue&type=style&index=0&id=0c3c5113&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3c5113",
  null
  
)

export default component.exports